const totalUnits = 10 * 20;

export default {
	data() {
		return {
			maxSeconds: totalUnits,
			secondsLeft: totalUnits,
			timerRef: null
		};
	},
	methods: {
		tickTime() {
			clearInterval(this.timerRef);
			this.secondsLeft = this.secondsLeft - 1;
			if (this.secondsLeft === 0) {
				this.quit();
			} else {
				this.timeSecond();
			}
		},
		quit() {
			this.$store.commit("begin");
			this.$router.push({ name: "home" });
		},
		timeSecond() {
			this.timerRef = setInterval(
				function() {
					this.tickTime();
				}.bind(this),
				50
			);
		}
	},
	destroyed() {
		clearInterval(this.timerRef);
	},
	mounted() {
		this.timeSecond();
	}
};
